import styled from 'styled-components';

const AIH_Header = styled.div`
  display: flex;
  border-radius: 4px;
  padding: 1.1em 0;
  border: solid 1px ${props => props.theme.color.border};
  height: 60px;
  color: ${props => props.theme.color.text};
`;

const AIH_ImgWrapper = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  min-width: 40px;
  > img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

const AIH_InfoBlock = styled.div`
  margin-left: 15px;
  > span {
    display: inline-block;
    width: 100%;
    &.new-user {
      font-weight: 500;
      color: #24ac8d;
    }
    &:first-of-type {
      font-size: 1.1em;
    }
    &:last-of-type {
      color: ${props => props.theme.color.label};
      font-size: 0.9em;
    }
  }
`;

const AIH_InfoCircleSm = styled.label`
  right: 0px;
  top: -5px;
  position: absolute;
  transform: translateY(50%);
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  &.Validated {
    background-color: #3accac;
  }
  &.NotValidated {
    background-color: ${(p) => p.theme.color.gold};
  }
  &.Blocked {
    background-color: ${props => props.theme.color.error};
  }
`;

const AIH_Section = styled.div`
  flex: 1;
  padding: 10px 0px;
  margin-left: 2%;
  display: flex;
  &:not(:last-of-type) {
    border-right: solid 1px ${props => props.theme.color.border};
  }
  &.appointment-info {
    flex-grow: 1.35;
    justify-content: space-between;
    > div {
      display: flex;
      align-items: center;
    }
  }
`;

const AIH_TimeBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5%;
  span {
    font-size: 1.5em;
    margin-left: 0.8em;
  }
`;

export { AIH_Header, AIH_ImgWrapper, AIH_InfoBlock, AIH_InfoCircleSm, AIH_Section, AIH_TimeBlock };
